import { Headers } from '@egw/components'
import { InvestmentsOverviewHoldingsDetails } from '@egw/features-holdings'
import { useTranslation } from '@egw/i18n'
import { Layout } from '@egw/layouts'
import { type FC } from 'react'

export const InvestmentsOverviewHoldingsDetailsPage: FC = () => {
  const { t } = useTranslation()

  return (
    <Layout>
      <Headers title={t('pages.investment_holdings_details_overview.title')} />
      <InvestmentsOverviewHoldingsDetails />
    </Layout>
  )
}
